import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroup from 'shared/ui/FormGroup/FormGroup';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import ChipInput from 'shared/ui/Input/ChipInput/ChipInput';
import ITag from 'shared/model/ITags';


import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';

import {normalizeTags} from '../../lib/normalizeTags';
import {tagsAPI} from '../../api/tagsAPI';

interface ITagsModalProps {
    open: boolean,
    tags?: (ITag | string)[],
    dialogClassName?: string,
    handleClose: () => void,
    // eslint-disable-next-line no-unused-vars
    onSave: (tags: string[]) => Promise<void>,
}

interface ITagsForm {
    tags: string[],
}

const getTagLabels = (tags?: (ITag | string)[]): string[] => (tags ?? [])
    .filter((tag): tag is ITag => typeof tag === 'object' && tag !== null && 'label' in tag)
    .map(tag => tag.label);

const TagsModal: React.FC<ITagsModalProps> = ({open, tags, dialogClassName, handleClose, onSave}) => {
    const {control, handleSubmit, reset} = useForm<ITagsForm>({
        defaultValues: {
            tags: [],
        },
    });

    const {data: allTags = [], refetch: refetchTags} = tagsAPI.useGetTagsQuery(undefined, {skip: !open});

    useEffect(() => {
        reset({tags: getTagLabels(tags)});
    }, [tags, reset, open]);

    const onSubmit = async(data: ITagsForm) => {
        await onSave(normalizeTags(data.tags));
        await refetchTags();
        handleClose();
    };

    const handleCloseModal = () => {
        reset();
        handleClose();
    };

    return (
        <MainModal
            header={t`Редактирование тегов`}
            open={open}
            handleClose={handleClose}
            size="md"
            dialogClassName={dialogClassName}
        >
            <ModalBodyWrapper>
                <FormGroup>
                    <label>{t`Теги`}</label>
                    <ChipInput
                        name="tags"
                        control={control}
                        availableOptions={allTags.map(tag => tag.label)}
                    />
                </FormGroup>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Сохранить`}
                primaryButtonType="submit"
                primaryButtonOnClick={handleSubmit(onSubmit)}
                secondaryButtonOnClick={handleCloseModal}
            />
        </MainModal>
    );
};

export default TagsModal;
